module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider6Pre-65a0481b.jpeg";